import { useState, useEffect } from "react";
import ComponentLoading from "../../../components/loading/Index";
import linhaimg from "../../../assets/linha/linem.png";
import ConfigRedirection from "../../../routes/redirection/ConfigRedirection";
import LogoImage from "../../../assets/logo/logo-03.png";
import ComponentFooter from "../../../components/footer/Index";
import useMobileResolution from "../../../hooks/useMobileResolution";
import ComponentePreCadastro from "../../../components/pre_cadastro/PreCadastroComponente";

function MobileView() {
  return (
    <div className="  h-screen bg-gradient-to-b from-[#f2f2f2] to-[#fcfcfd]">
      {/* Botão do Menu (aparece apenas em telas pequenas) */}
      <div className="w-full bg-[#eceae7] text-white">
        <div className="flex flex-nowrap justify-center w-full overflow-hidden">
          {[...Array(20)].map((_, index) => (
            <img
              key={index}
              src={linhaimg}
              alt="Linha Versace"
              className="w-28 h-auto opacity-40"
            />
          ))}
        </div>

        <div className="p-5 w-full md:w-auto bg-[#baa78e] bg-opacity-10">
          <img src={LogoImage} alt="Logo" className="h-28 mx-auto" />
        </div>

        <div className="flex flex-nowrap justify-center w-full overflow-hidden">
          {[...Array(20)].map((_, index) => (
            <img
              key={index}
              src={linhaimg}
              alt="Linha Versace"
              className="w-28 h-auto opacity-40"
            />
          ))}
        </div>
      </div>
      <ComponentePreCadastro />
    </div>
  );
}
function DesktopView() {
  return (
    <>
      <div className="flex flex-col h-screen">
        {/* Colunas do meio */}
        <div className="flex flex-grow">
          {/* Coluna do menu */}

          <div className="w-full md:flex-1 bg-gradient-to-r from-[#f2f2f2] to-[#f2f2f2]">
            <div className="flex flex-nowrap justify-center w-full overflow-hidden">
              {[...Array(20)].map((_, index) => (
                <img
                  key={index}
                  src={linhaimg}
                  alt="Linha Versace"
                  className="w-28 h-auto opacity-40"
                />
              ))}
            </div>

            <div className="p-5 w-full md:w-auto bg-[#baa78e] bg-opacity-10">
              <img src={LogoImage} alt="Logo" className="h-28 mx-auto" />
            </div>

            <div className="flex flex-nowrap justify-center w-full overflow-hidden">
              {[...Array(20)].map((_, index) => (
                <img
                  key={index}
                  src={linhaimg}
                  alt="Linha Versace"
                  className="w-28 h-auto opacity-40"
                />
              ))}
            </div>

            <div className="flex items-center justify-center bg-cover bg-center mb-10">
              <div className="flex justify-center items-center self-center w-full max-w-xl p-6 rounded-2xl">
                <div className="w-full">
                  <ComponentePreCadastro />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Rodapé */}
        <ComponentFooter />
      </div>
    </>
  );
}

function Index() {
  const [configRendered, setConfigRendered] = useState(false);
  const deviceType = useMobileResolution();

  useEffect(() => {
    setTimeout(() => setConfigRendered(true), 2000);
  }, []);

  return (
    <div className="h-screen bg-[#fcf3e8]">
      {!configRendered && <ComponentLoading />}

      {configRendered && (
        <>
          <ConfigRedirection />
          {deviceType === "mobile" ? (
            <MobileView />
          ) : (
            <DesktopView deviceType={deviceType} />
          )}
        </>
      )}
    </div>
  );
}

export default Index;
